export function isEmptyObj(obj) {
  for (var _x in obj) {
    return false;
  }

  return true;
}
//# sourceMappingURL=isEmptyObj.js.map